import { BaseGQLService } from '../../../../common/services/BaseGQLService';
import { ModelType } from '../../../../common/utils/GQLIdEncoder';
import { InstanceExportOptions } from '../../../options/InstanceExportOptions';
import { REPORT_SUMMARY_FRAGMENT } from '../../report/services/ReportPrintRepository';
import { InstancePrintMapper } from '../mappers/InstancePrintMapper';
import { InstancePrintData } from '../models/InstancePrintData';

export const GET_INSTANCE_PRINT_QUERY = `
query ($reportId: ID!, $ruleNumber: String!, $instanceId: ID!, $includeFilteredRules: Boolean!) {
  report: node(id: $reportId) {
    ... on ReportDone {
      ${REPORT_SUMMARY_FRAGMENT}
      rules(includeFilteredRules: $includeFilteredRules, filters: {field: number, operation: EQ, value: $ruleNumber}) {
        edges {
          node {
            number
            title
            severity
            shortExplanation
            explanation
            consequences
            access
            expertise
            resources
            kbLink
          }
        }
      }
    }
  }
  instance: node(id: $instanceId) {
    ... on Instance {
      number
      numberLocal
      severity
      data
      filterStatus
      remediation {
        general {
          remediation
          triage
          specificRemediationAdvice
          link
        }
        specificTag
      }
      hardCodedStringLocations {
        line
      }
      calls {
        totalCount
      }
      operations {
        totalCount
      }
      locations {
        totalCount
      }
    }
  }
}
`;

export class InstancePrintRepository extends BaseGQLService {
  private readonly mapper = new InstancePrintMapper();

  protected addTypename(): boolean {
    return false;
  }

  async getInstance(options: InstanceExportOptions): Promise<InstancePrintData> {
    const { instanceId, reportId, issueNumber, includeFilteredItems } = options;
    return this.query(
      GET_INSTANCE_PRINT_QUERY,
      {
        instanceId: this.gqlIdEncoder.encode(ModelType.Instance, instanceId),
        reportId: this.gqlIdEncoder.encode(ModelType.Report, reportId),
        ruleNumber: issueNumber.toString(),
        includeFilteredRules: includeFilteredItems,
      },
      (data) => this.mapper.mapGQLModel(data.instance, data.report)
    );
  }
}
